
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M30.17 11.55C28.57 8.21 24.26 7 24.26 7s-2.24 5.9 1.5 9.17"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M23.76 12.59c-2.18-1.15-4.08-.54-4.08-.54s-.44 5.23 4.52 7.08l-4.53 24.53c-.79 4.26 2.28 8.52 5.44 8.52h10.13c3.15 0 6.22-4.26 5.44-8.52l-4.53-24.53c4.96-1.85 4.52-7.08 4.52-7.08s-1.9-.61-4.08.54"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M21.82 17.68C19.15 18.07 17 19.7 17 19.7s1.75 3.96 6.6 2.93m6.57-11.08C31.77 8.21 36.08 7 36.08 7s2.24 5.9-1.5 9.17m3.95 1.51c2.67.39 4.82 2.02 4.82 2.02s-1.75 3.96-6.6 2.93m-8.96-4.95l-1.28 24.15c0 2.02 1.64 3.67 3.67 3.67 2.03 0 3.67-1.64 3.67-3.67l-1.28-24.15M26.1 52.19v-.91c0-1.12.91-2.03 2.03-2.03h4.08c1.12 0 2.03.91 2.03 2.03v.91"}})])
          )
        }
      }
    